export const StorageKeys = {
  AuthToken: 'Band_Portal_AuthToken',
  AuthTokenExpiresIn: 'Band_Portal_AuthTokenExpiresIn',
  LoggedUser: 'Band_Portal_LoggedUser',
  AuthEmail: 'Band_Portal_AuthEmail',
  Cache: 'Band_Portal_Cache',
  AuthExecutive: 'Band_Executive',
  AuthIdentity:
    'oidc.user:https://auth.bandeirantes.digital:f29959b8e41f45b1882c7044440bd046'
};
